/**
 * CodeableConcept de serviceCategory para Schedules de Pronto Atendimento.
 * Ponto de alinhamento com a terminologia Fluxmed — ajustar system/code se
 * o CodeSystem oficial for publicado com outro identificador.
 */

export const PRONTO_ATENDIMENTO_SERVICE_CATEGORY = {
  system: "https://fluxmed.com.br/fhir/CodeSystem/service-category",
  code: "pronto-atendimento",
  display: "Pronto Atendimento",
} as const;

/** Token de busca FHIR: system|code */
export const PRONTO_ATENDIMENTO_SERVICE_CATEGORY_TOKEN = `${PRONTO_ATENDIMENTO_SERVICE_CATEGORY.system}|${PRONTO_ATENDIMENTO_SERVICE_CATEGORY.code}`;

/** Extension: marca no máx. 1 Schedule como pré-selecionado no Pronto Atendimento. */
export const PRONTO_ATENDIMENTO_DEFAULT_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/schedule-default-pronto-atendimento";

export const SERVICE_COST_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/service-cost";

export const SCHEDULE_ATTENDANCE_TYPE_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/schedule-attendance-type";

export const ATTENDANCE_CHANNEL_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/attendance-channel";
